// create a function that takes a compEvent and a SocketResultMessagePayloadTrackMoveVert payload and
// returns a new compEvent.
// e.g. {
//   checkedIn: false,
//   factor: -1,
//   egId: 14425,
//   heatNo: 3
// }
// the factor is The number of places to move the entire heat -1 is backwards positive is forwards
import type {
  CompEvent,
  HeatNoString,
  IndividualEntry
} from '@/components/results/store-comp-results'
import type { SocketResultMessagePayloadTrackMoveVert } from '@/components/results/socket/track-movevert/models/track-movevert'
import { simpleClone } from '@/services/common-service-utils'
import { getEntriesGroupedByHeatNo } from '@/components/results/results-service'
import type { SocketResultMessagePayloadEntriesPresent } from '@/components/results/socket/entries-present/models/entries-present'
import type { AthleteIdString, EntryIdString } from '@/services/common'

export function updateTrackMoveVert(
  compEvent: CompEvent,
  payload: SocketResultMessagePayloadTrackMoveVert
): CompEvent {
  const compEventInternal = simpleClone(compEvent)

  const groupedByHeatNo = getEntriesGroupedByHeatNo(compEventInternal)

  const heatNoToMoveTo: number = payload.heatNo + payload.factor

  //  If heat number to move to is below 0 or above the maximum size of the array then exit
  if (heatNoToMoveTo < 0 || heatNoToMoveTo > Object.keys(groupedByHeatNo).length) {
    return compEventInternal
  }

  //  get the groupedByHeatNo as an array
  const heats = Object.values(groupedByHeatNo)

  //sort the heats by heatNo
  heats.sort((a, b) => {
    return a[0].seeding.heatNo - b[0].seeding.heatNo
  })

  //  remove the heat to move from the array
  const heatToMove = heats.splice(payload.heatNo - 1, 1)[0]

  //  insert the heat to move to the new position
  heats.splice(heatNoToMoveTo - 1, 0, heatToMove)

  //  update the seeding for each entry
  heats.forEach((heat, index) => {
    heat.forEach((entry) => {
      entry.seeding.heatNo = index + 1
    })
  })

  // now put the heats back into the compEventInternal.entries
  heats.forEach((heat) => {
    heat.forEach((entry) => {
      compEventInternal.entries![entry.athleteId.toString()] = entry
    })
  })

  return compEventInternal
}
